import React, { FC, useCallback } from 'react';

import { spacing } from '@rbilabs/universal-components/themes';
import { SafeAreaView, View } from 'react-native';

import { CenteredRowContainer } from 'components/layout/centered-row-container';
import LoadingAnimation from 'components/loading-animation';
import { Table } from 'components/table';
import { isNative } from 'utils/environment';
import { ITable } from 'utils/table';

import { TransactionTable, TransactionTableRow } from './types';

interface HistoryLazyTableListProps {
  tables: TransactionTable[];
  visibleTransactions?: number;
  handleOnPressRow: (row: TransactionTableRow | Partial<TransactionTableRow>) => void;
  loadingMore?: boolean;
}

export const HistoryLazyTableList: FC<HistoryLazyTableListProps> = ({
  tables,
  visibleTransactions,
  handleOnPressRow,
  loadingMore,
}) => {
  const renderItem = useCallback(
    ({ item, index }: { item: ITable<Partial<TransactionTableRow>>; index: number }) => (
      <Table<TransactionTableRow>
        key={`historyTable.${index}`}
        table={item}
        onPressRow={handleOnPressRow}
        marginTop="$4"
      />
    ),
    [handleOnPressRow]
  );

  const visibleTables = React.useMemo(() => {
    if (isNative && visibleTransactions) {
      return tables.slice(0, visibleTransactions);
    }
    return tables;
  }, [tables, visibleTransactions]);

  // Lazy Loading only for Native...
  if (isNative && visibleTransactions) {
    return (
      <SafeAreaView style={{ flex: 1 }}>
        {visibleTables.map((item, index) => renderItem({ item, index }))}
        {loadingMore && (
          <CenteredRowContainer>
            <View style={{ padding: spacing.$8 }}>
              <LoadingAnimation />
            </View>
          </CenteredRowContainer>
        )}
      </SafeAreaView>
    );
  }

  return (
    <SafeAreaView style={{ flex: 1 }}>
      {visibleTables.map((item, index) => renderItem({ item, index }))}
    </SafeAreaView>
  );
};
